import React from "react";
import styles from "./index.module.scss";
import { sessionNoteTypes } from "../../partials/sessionNotes";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { getLocalValue } from "../../utils/auth";
import { useTranslation } from "react-i18next";
import moment from "moment";

// Example List item:
// [
//   {
//     id: 123,
//     type_id: 2,
//     note: "Keep up the good work",
//     like: true,
//     author: "John Doe",
//     author_id: 12000,
//     liked_by_coach: true,
//     liked_by_coachee: true,
//   },
// ]

export default function NotesList({
  handleLike,
  list,
  setList,
  canLike,
  ...props
}) {
  const { t } = useTranslation();
  const likeClick = index => {
    // flips "like" Boolean value on local list.
    let newList = JSON.parse(JSON.stringify(list));
    const newVal = !newList[index].like;
    const id = newList[index].id;
    newList[index].like = newVal;
    setList(newList);

    // sends "like" update API request
    if (handleLike) {
      handleLike(id, newVal);
    }
  };

  const getType = type_id => {
    return sessionNoteTypes.find(o => {
      return o.type_id === type_id;
    });
  };

  return (
    <div className={styles.container}>
      {list.map((item, index) => {
        let yourOwnMessage =
          parseInt(item.author_id) === parseInt(getLocalValue("uid"));
          const now = moment(); // Current date and time
          const noteDate = moment.utc(item.note_created_at, "YYYY-MM-DD HH:mm:ss").local();
          const diffMinutes = now.diff(noteDate, 'minutes'); // Difference in minutes
          const diffHours = now.diff(noteDate, 'hours'); // Difference in hours
  
          let formattedDate;
          if (diffMinutes < 1) { // Less than 1 minute
            const diffSeconds = now.diff(noteDate, 'seconds'); // Difference in seconds
            formattedDate = diffSeconds <= 1 ? <span style={{ fontSize: '12px', color: '#00000099' }}> just now </span> : <span style={{ fontSize: '12px', color: '#00000099' }}>{diffSeconds} seconds ago</span>;
          } else if (diffHours < 1) { // Less than 1 hour
            formattedDate = diffMinutes === 1 ? <span style={{ fontSize: '12px', color: '#00000099' }}>1 minute ago</span> : <span style={{ fontSize: '12px', color: '#00000099' }}>{diffMinutes} minutes ago</span>;
          } else if (diffHours < 24) { // Less than 24 hours
            formattedDate = diffHours === 1 ? <span style={{ fontSize: '12px', color: '#00000099' }}>1 hour ago</span> : <span style={{ fontSize: '12px', color: '#00000099' }}>{diffHours} hours ago</span>;
          } else {
            formattedDate = noteDate.format("DD MMMM YYYY, h:mm A"); // Show date and time
          }
        return (
          <div key={index} className={styles.listCard}>
            <div
              className={styles.cardAccent}
              style={{ backgroundColor: getType(item.type_id).color }}
            />
            <div className={styles.topBar}>
              <span
                className={styles.icon}
                style={{ color: getType(item.type_id).color }}
              >
                {getType(item.type_id).icon}
              </span>
              <span
                className={styles.typeLabel}
                style={{ color: getType(item.type_id).color }}
              >
                {t(getType(item.type_id).label)}
              </span>
              <span className={styles.author}>by {item.author}</span>

              {/* Only show like button on sessionNoteTypes that are likable. */}
              {getType(item.type_id).likable && (
                <span
                  className={styles.likeButton}
                  title={
                    item.liked_by_coach
                      ? "Liked by coach"
                      : item.liked_by_coachee
                        ? "Liked by coachee"
                        : null
                  }
                  style={{
                    color: item.like ? "#e35646" : "",
                    display: yourOwnMessage && !item.like ? "none" : "unset", // don't show like button if your own message is not liked
                  }}
                  onClick={() => {
                    // disable liking or unliking your own messages
                    if (canLike) {
                      if (!yourOwnMessage) {
                        likeClick(index);
                      }
                    }
                  }}
                >
                  <ThumbUpIcon />
                </span>
              )}
            </div>
            <div className={styles.content}>
              {item.note.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
              <span className={styles.date}>{formattedDate}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}